import React, { Component } from 'react';
import { connect } from 'react-redux';
import RequestManager from "../../../requests/RequestManager";
import ModalConductor from '../../../containers/Modal';
import { showModal, MODAL_LANGUAGES, MODAL_LANGUAGES_LIVE } from '../../../actions/modal';

import storage from '../../DeviceStorage/DeviceStorage';
import Device from "../../../devices/device";
import Translator from "../../../requests/apa/Translator";
import MultipleLangLive from '../../../AAF/LanguageLive/MultipleLangLive';
import Utils from '../../../utils/Utils';


class ContentLanguage extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            options: [],
            options_live_audio: [],
            options_live_subtitle: [],
        }
    this.jsonLangs=[
        {
          label_large: Translator.get('subtitled_in_spanish', 'Subtitulada al español'),
            option_id:"S-ES",
        },
        {
          label_large: Translator.get('subtitled_in_portuguese', 'Subtitulada al portugués'),
          option_id:"S-PT",
        },
        {
          label_large: Translator.get('original_language', 'Idioma Original'),
          option_id:"Ori",
        },
        {
          label_large: Translator.get('portuguese_language', 'Doblada al portugués'),
          option_id:"D-PT",
        },
        {
          label_large: Translator.get('spanish_language', 'Doblada al español'),
          option_id:"D-ES",
        }
    ];

    this.jsonMultiple = {
        audio: MultipleLangLive.getModalSettingsAudio(),
        subtitles: MultipleLangLive.getModalSettingsSubtitles()
    }
    this.device = Device.getDevice().getPlatform();
    this.focusHandler = this.focusHandler.bind(this);
    }

    componentWillMount() {
        const that = this;
        let option,
            value,
            value_live_audio,
            value_live_subtitle;
//        RequestManager.addRequest(this.rememeberRequest).then((resp) => {
//            if (resp.response.groups) {
//                this.setState({data: JSON.parse(JSON.stringify(resp.response.groups))});
//            }
//        }).catch((err) => {
//            console.error(err);
//        });
        if (storage.getItem('default_lang')) {
            value = storage.getItem('default_lang');
        }

        if(MultipleLangLive.isEnabled()){
            if (storage.getItem('default_lang_audio_live')) {
                value_live_audio = storage.getItem('default_lang_audio_live');
            }
            if (storage.getItem('default_lang_subtitle_live')) {
                value_live_subtitle = storage.getItem('default_lang_subtitle_live');
            }
        }


        if(!value || value && value.indexOf('O-')>-1) {
            storage.setItem('default_lang','Ori');
            value = 'Ori';
        }

        if(MultipleLangLive.isEnabled()){
            if(!value_live_audio || value_live_audio && value_live_audio.indexOf('O-')>-1) {
                storage.setItem('default_lang_audio_live','Ori');
                value_live_audio = 'Ori';
            }
              if(!value_live_subtitle || value_live_subtitle && value_live_subtitle.indexOf('O-')>-1) {
                storage.setItem('default_lang_subtitle_live','Ori');
                value_live_subtitle = 'Ori';
            }
        }


      this.jsonLangs.map((json)=>{
            if (json.option_id == value) {
                that.setState({options: {option: json.label_large, value: json.option_id}});
            }
      });


      if(MultipleLangLive.isEnabled()){
          this.jsonMultiple.audio.map((json)=>{
            if ((json.option_id && (typeof json.option_id == 'string')) && (value_live_audio && (typeof value_live_audio == 'string')) && (json.option_id.toUpperCase() == value_live_audio.toUpperCase())) {
                that.setState({options_live_audio: {option: json.label_large, value: json.option_id}});
            }
          });
    
          this.jsonMultiple.subtitles.map((json)=>{
            if ((json.option_id && (typeof json.option_id == 'string')) && (value_live_subtitle && (typeof value_live_subtitle == 'string')) && (json.option_id.toUpperCase() == value_live_subtitle.toUpperCase())) {
            //if (json.option_id == value_live_subtitle) {
                that.setState({options_live_subtitle: {option: json.label_large, value: json.option_id}});
                }
          });
      }



    }

    componentDidMount() {
        window.SpatialNavigation.makeFocusable();
    }

    focusHandler(data) {
    }

    stateHandler(value) {
        const that = this;
        this.jsonLangs.map((json)=>{
            if (json.option_id == value.option_id) {
              storage.setItem('default_lang',json.option_id);
                that.setState({options: {option: json.label_large, value: json.option_id}});
            }
        });
    }


    stateHandlerLive(isAudio, it){
        const that = this;
        if(isAudio){
            this.jsonMultiple.audio.map((json)=>{
                if (json.option_id == it.option_id) {
                  storage.setItem('default_lang_audio_live',json.option_id);
                  that.setState({options_live_audio: {option: json.label_large, value: json.option_id}});
                }
            });
        }else{
            this.jsonMultiple.subtitles.map((json)=>{
                if (json.option_id == it.option_id) {
                  storage.setItem('default_lang_subtitle_live',json.option_id);
                  that.setState({options_live_subtitle: {option: json.label_large, value: json.option_id}});
                }
            });
        }
        
        
    }

    keyActions(key) {
        const showModal = this.props.showModal;
        const modal =  document.getElementsByClassName('modal-overlay');

        switch (key) {
            case 'OK':
                if (modal.length === 0) {
                    console.log('muestra modal')
                    showModal({ 
                        modalType: MODAL_LANGUAGES, 
                        modalProps: { languages: this.jsonLangs, type: 'lang', callback: (a) => { this.stateHandler(a) },  onMouseEnter: this.handleMouseEnter, },                       
                    });
                }
                break;
        }
    }

    keyActionsLive(key) {
        const showModal = this.props.showModal;
        const modal =  document.getElementsByClassName('modal-overlay');

        switch (key) {
            case 'OK':
                if (modal.length === 0) {
                    showModal({ modalType: MODAL_LANGUAGES_LIVE, modalProps: { languages: this.jsonMultiple, type: 'lang_multiple_live', callback: (isAudio, a) => { this.stateHandlerLive(isAudio, a) } } });
                }
                break;
        }
    }

    handleMouseEnter(e){
        Utils.handleMouseEnter(e)
    }

    render() {
        return(
            (
            !MultipleLangLive.isEnabled() ? 
                <div id="" className="ContentLanguage">
                    <p>{ this.props.text }</p>
                    <small>{this.props.notApply}</small>
                    <div className="frameLanguage">
                    <div className="content">
                        {Translator.get('choose_language_settings', 'Seleccione su idioma')}
                            <a  onMouseEnter={() => this.handleMouseEnter('language-button')} onClick={ ()=>{ this.keyActions('OK') } } id="language-button" className="focusable">
                                { this.state.options.option } <i className="fa fa-angle-down fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            : 
                <div id="" className="ContentLanguageMultiple">
                    <div className="container-multiple">
                        <div className="header-settings">
                        {Translator.get('label_on_demand_title', 'On demand')}
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col-section-one">
                            {Translator.get('label_on_demand_description', 'Aqui puedes configurar el idioma y subtítulos para los contenidos on demand.')}
                                
                            </div>
                            <div className="col-section-two">
                                <div className="frameLanguage">
                                    <div className="content">
                                    {Translator.get('choose_language_settings', 'Seleccione su idioma')}
                                        <a href="javascript:void(0)" onMouseEnter={() => this.handleMouseEnter('language-button')}  onClick={ ()=>{ this.keyActions('OK') } } id="language-button" className="focusable">
                                            { this.state.options.option } <i className="fa fa-angle-down fa-lg" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-multiple">
                        <div className="header-settings">
                        {Translator.get('label_on_live_title', 'TV')}
                        </div>
                        <hr/>
                        <div className="row">
                            <div className="col-section-one">
                            {Translator.get('label_on_live_description', 'Aqui puedes configurar el idioma y subtítulos para los contenidos lineales.')} 
                            </div>
                            <div className="col-section-two">
                                <div className="frameLanguage">
                                    <div className="content content-option">
                                    {Translator.get('choose_language_settings', 'Seleccione su idioma')}
                                        <a href="javascript:void(0)" onMouseEnter={() => this.handleMouseEnter('language-button')}  onClick={ ()=>{ this.keyActionsLive('OK') } } id="language-button" className="focusable">
                                            { this.state.options_live_audio.option } /  { this.state.options_live_subtitle.option } <i className="fa fa-angle-down fa-lg" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )
 
        );
    }
}

export default connect(null,{showModal})(ContentLanguage);



// WEBPACK FOOTER //
// ./src/components/User-Settings/ContentLanguage/index.jsx